import { render, staticRenderFns } from "./collapse_event.vue?vue&type=template&id=5874ad5e"
import script from "./collapse_event.vue?vue&type=script&lang=js"
export * from "./collapse_event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports